import { action, observable, computed } from 'mobx'
import { VIPChannel } from '@modules/common/models/enums/VIPChannel'
import { CancelProductDataStore } from './CancelProductDataStore'

const ChannelTabs = [
  {
    id: VIPChannel.Wholesale,
    name: 'Wholesale',
    key: 'channelTabs.wholesale'
  },
  {
    id: VIPChannel.Retail,
    name: 'Retail',
    key: 'channelTabs.retail'
  }
]

export class CancelProductUIStore extends CancelProductDataStore {
  @observable selectedChannel = ''
  selectedRows = []

  @action
  setSelectedChannel = channel => {
    this.selectedChannel = channel
  }

  @computed
  get tabs() {
    return ChannelTabs.filter(tab => tab)
  }

  @action
  reset = () => {
    this.productOrderDetails = null
    this.selectedChannel = ''
  }
}
